import React, { useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import MomentUtils from '@date-io/moment';
import { create } from 'jss';
import rtl from 'jss-rtl';

import ThemeProvider from '@material-ui/styles/ThemeProvider';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { createTheme, jssPreset, StylesProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';

import AppContext from '../../contexts/AppContext/AppContext';
import AppLayout from '../layout';

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

const AppWrapper = ({ children }) => {
  const { theme } = useContext(AppContext);
  const location = useLocation();

  const muiTheme = useMemo(() => {
    return createTheme(theme);
  }, [theme]);

  const isStaging = process.env.REACT_APP_ENV === 'staging';
  const isReportExport = location.pathname.includes('/report-export/');

  return (
    <ThemeProvider theme={muiTheme}>
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <StylesProvider jss={jss}>
          <CssBaseline />
          {isStaging && !isReportExport && (
            <div data-staging-banner="true"
              style={{
                width: '100%',
                backgroundColor: '#DF3371',
                textAlign: 'center',
                fontWeight: 'bold',
                color: 'white',
                fontSize: '16px',
                padding: '6px 0',
              }}>
              STAGING APP
            </div>
          )}
          {isReportExport ? children : <AppLayout>{children}</AppLayout>}
        </StylesProvider>
      </MuiPickersUtilsProvider>
    </ThemeProvider>
  );
};

export default AppWrapper;
